import { render } from "./Unsubscription.vue?vue&type=template&id=35e86b0e&scoped=true"
import script from "./Unsubscription.vue?vue&type=script&lang=js"
export * from "./Unsubscription.vue?vue&type=script&lang=js"

import "./Unsubscription.vue?vue&type=style&index=0&id=35e86b0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e86b0e"]])

export default __exports__